import styled from '@emotion/styled';

import { breakpoints } from '@/shared/design/media';
import { commonColors } from '@/shared/design/tokens/themes';
import { headingsNew, paragraphsNew } from '@/shared/design/tokens/typography';

export const ContactsWrapper = styled.section({
  width: '90%',
  maxWidth: '1240px',
  display: 'flex',
  gap: '20px',
  justifyContent: 'space-between',
  marginBottom: '216px',

  [`@media (max-width:${breakpoints.tablet}px)`]: {
    flexDirection: 'column',
  },

  [`@media (max-width:${breakpoints.mobile}px)`]: {
    marginBottom: '150px',
  },
});

export const Map = styled.div<{ $bgImage: string }>((props) => ({
  width: '100%',
  maxWidth: '610px',
  minHeight: '610px',
  backgroundImage: `url(${props.$bgImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '50px',

  [`@media (max-width:${breakpoints.tablet}px)`]: {
    maxWidth: '100%',
    minHeight: '500px',
  },

  [`@media (max-width:${breakpoints.mobile}px)`]: {
    minHeight: '410px',
  },
}));

export const MapFrame = styled.div({
  position: 'relative',
  width: '100%',
  maxWidth: '610px',
  minHeight: '610px',
  overflow: 'hidden',
  borderRadius: '50px',
  backgroundColor: commonColors.darkGrey_hover,

  [`@media (max-width:${breakpoints.tablet}px)`]: {
    maxWidth: '100%',
    minHeight: '500px',
  },

  [`@media (max-width:${breakpoints.mobile}px)`]: {
    minHeight: '410px',
  },
});

export const MapCanvas = styled.div({
  position: 'absolute',
  inset: 0,
});

export const MapState = styled.div({
  ...paragraphsNew.base,
  position: 'absolute',
  inset: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '20px',
  padding: '24px',
  backgroundColor: 'rgba(0, 0, 0, 0.68)',
  color: commonColors.white,
  textAlign: 'center',

  [`@media (max-width:${breakpoints.mobile}px)`]: {
    ...paragraphsNew.base_adaptive,
  },
});

export const MapConsentButton = styled.button({
  minHeight: '48px',
  padding: '0 20px',
  color: commonColors.white,
  backgroundColor: commonColors.violet,
  border: 0,
  borderRadius: '999px',
  font: 'inherit',
  fontSize: '16px',
  lineHeight: 1.2,
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',

  '&:hover': { backgroundColor: commonColors.violet_hover },
  '&:focus-visible': {
    outline: `3px solid ${commonColors.white}`,
    outlineOffset: '3px',
  },
});

export const ContactsBlock = styled.div({
  width: '100%',
  maxWidth: '610px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: commonColors.violet,
  color: commonColors.white,
  borderRadius: '50px',

  [`@media (max-width:${breakpoints.tablet}px)`]: {
    maxWidth: '100%',
    paddingBlock: '50px',
  },
});

export const Title = styled.h2({
  ...headingsNew.title1_adaptive,
  margin: '120px 0 30px',

  [`@media (max-width:${breakpoints.laptop}px)`]: {
    marginTop: '100px',
  },

  [`@media (max-width:${breakpoints.tablet}px)`]: {
    marginTop: '0',
  },

  [`@media (max-width:${breakpoints.mobile}px)`]: {
    ...headingsNew.heading1_adaptive,
  },
});

export const Site = styled.a({
  width: '100%',
  ...paragraphsNew.base,
  marginBottom: '20px',
  color: commonColors.white,
  textAlign: 'center',
  transition: 'opacity 0.2s ease-in-out',

  '&:hover': {
    cursor: 'pointer',
    opacity: '0.6',
  },

  [`@media (max-width:${breakpoints.mobile}px)`]: {
    ...paragraphsNew.base_adaptive,
  },
});

export const Email = styled.p({
  ...paragraphsNew.base,
  marginBottom: '60px',

  [`@media (max-width:${breakpoints.mobile}px)`]: {
    ...paragraphsNew.base_adaptive,
    marginBottom: '40px',
  },
});

export const Address = styled.div({
  ...paragraphsNew.base,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',
  marginBottom: '88px',
  textAlign: 'center',

  [`@media (max-width:${breakpoints.mobile}px)`]: {
    ...paragraphsNew.base_adaptive,
    marginBottom: '65px',
  },
});

export const Socials = styled.div({
  display: 'flex',
  gap: '16px',
});
